import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IContactUpdateResource } from "../../shared/types";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItemWrapper,
} from "../../shared/view";
const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: phone;
`;

export const ArchivedContactViewPhoneNumberSection: FC<{ contact: IContactUpdateResource }> = ({ contact }) => {
	const { t } = useTranslation();

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Phone numbers")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{contact.contactPhones.map((x) => (
					<ViewPageSectionListItemWrapper key={x.id}>
						{x.phoneNumber} {x.isPrimary && <PrimaryLabel />}
					</ViewPageSectionListItemWrapper>
				))}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
